import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ClientLogo from "../../components/ClientLogo/ClientLogo";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Menu, MenuItem } from "@mui/material";
import ViewRomReport from "../../components/ViewRomReport/ViewRomReport";
import { getReportData } from "../../services/ViewReportServices";
import ViewRepReport from "../../components/ViewRepReport/ViewRepReport";
import ViewHoldReport from "../../components/ViewHoldReport/ViewHoldReport";
import { useAuth } from "../../auth";
import HomeIcon from "../../assets/Icons/home.svg";
import { useNavigate } from "react-router-dom";

const ViewReport = () => {
  const { sessionId } = useParams();
  const [reportData, setReportData] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const auth = useAuth();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    auth.logout();
  };
  useEffect(() => {
    console.log("sessionId", sessionId);
    getReportData(sessionId).then((res) => {
      console.log("data", res);
      setReportData(res.data);
    });
  }, [sessionId]);

  const refreshDataHandler = () => {
    getReportData(sessionId).then((res) => {
      setReportData(res.data);
    });
  }

  return (
    <div className="max-w-[1440px] mx-auto my-0 bg-[#F5F9FF]">
      <div className="flex justify-between bg-[#E1EDFF] pl-[68px] pr-[84px] items-center pt-6 pb-5">
        <div>
          <ClientLogo customClassName="w-[150px] h-[56px]" />
        </div>
        <div>
          <AccountCircleOutlinedIcon
            sx={{
              height: "30px",
              width: "30px",
              color: "#415280",
            }}
            onClick={handleClick}
          />
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={handleClose}>Logout</MenuItem>
          </Menu>
        </div>
      </div>
      <div className="max-w-[1280px] mx-auto my-0">
        <div className="mt-[74px] flex items-center text-[#415280] text-sm leading-[21px] pb-3 border-b border-solid border-[#DADFFF] font-semibold gap-2">
          <div>
            <img
              src={HomeIcon}
              alt=""
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div>{">"}</div>
          <div>
            {reportData && reportData.end_user && (
              <span>{reportData.end_user.name}'s</span>
            )}{" "}
            Report
          </div>
        </div>
        <div className="flex justify-end pt-5 pb-3">
          {/* <Button
            sx={{
              backgroundColor: "#788CFC",
              color: "#FFFFFF",
              textTransform: "none",

              "&:hover": {
                backgroundColor: "#788CFC",
                color: "#FFFFFF",
              },
            }}
          >
            Save
          </Button>
          <Button>Export to pdf</Button> */}
        </div>
        <div>
          <div
            className="bg-[#415280] text-[#fff] text-xs leading-[18px] font-semibold px-6 py-4
            "
          >
            <div>
              {reportData && reportData.end_user && (
                <span>{reportData.end_user.name}'s</span>
              )}{" "}
              Report
            </div>
          </div>
          <div className="border border-solid border-[#DADFFF] px-[52px] pt-6 bg-white">
            <div>
              <ul>
                {/* <li>
                  Click on the Video Links below each exercise thumbnail to see
                  individual Videos
                </li>
                <li>
                  Edit the measured angle as needed the video pop up itself
                </li>
                <li>
                  After editing all required videos, save the report before you
                  export it.
                </li> */}
              </ul>
          </div>
            <div>
              {reportData.mobility_and_flexibility_response &&
                reportData.mobility_and_flexibility_response
                  .mobility_and_flexibility_exercise_results && (
                  <ViewRomReport
                    data={
                      reportData.mobility_and_flexibility_response
                        .mobility_and_flexibility_exercise_results
                    }
                    refreshDataHandler={refreshDataHandler}
                  />
                )}
            </div>
            <div>
              {reportData.strength_and_endurance_response &&
                reportData.strength_and_endurance_response
                  .reps_output_list && (
                  <ViewRepReport
                    data={
                      reportData.strength_and_endurance_response
                        .reps_output_list
                    }
                    refreshDataHandler={refreshDataHandler}
                  />
                )}
            </div>
            <div>
              {reportData.balance_response &&
                reportData.balance_response
                  .assessment_report_for_balance_list && (
                  <ViewHoldReport
                    data={
                      reportData.balance_response
                        .assessment_report_for_balance_list
                    }
                    refreshDataHandler={refreshDataHandler}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReport;
